export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-950">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-background-50 tracking-wide mb-4">
          投稿爆料
        </h2>
        <p className="text-base md:text-lg text-foreground-300 mb-3">
          有猛料？匿名直发
        </p>
        <p className="text-sm text-foreground-400 mb-10">
          审核后即时上线，你的身份永远保密
        </p>

        <button className="inline-flex items-center gap-0 bg-primary-500 text-background-50 rounded-full overflow-hidden hover:bg-primary-600 transition-colors cursor-pointer border-0 whitespace-nowrap">
          <span className="flex items-center justify-center w-12 h-12 bg-background-950/30">
            <i className="ri-send-plane-fill text-lg w-5 h-5 flex items-center justify-center"></i>
          </span>
          <span className="px-6 py-3 text-sm md:text-base font-bold flex items-center gap-2">
            立即投稿
            <i className="ri-arrow-right-up-line text-lg w-4 h-4 flex items-center justify-center"></i>
          </span>
        </button>

        <p className="mt-8 text-xs text-foreground-500">
          我们严格保护爆料人隐私，所有投稿均采用端到端加密传输
        </p>
      </div>
    </section>
  );
}